import {
  faCalendarWeek,
  faComment,
  faVideo,
} from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  capitalizeFirstLetter,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"

import NotificationDot from "../../components/notificationDot/NotificationDot"
import useMobile from "../../hooks/useMobile"
import { useGetMeTabCardQuery } from "../../networking/queries"
import { useRouter } from "../../util/router"

export enum CoachTab {
  MESSAGES = "messages",
  ROUTINE = "routine",
  SESSIONS = "sessions",
}

const CoachTabNav = () => {
  const { data: meTabCard } = useGetMeTabCardQuery()
  const isMobile = useMobile()
  const router = useRouter()
  const tab = router.query.coachTab as CoachTab | undefined
  const careTeamUserId = router.query.careTeamUserId as string | undefined

  const setTab = (tab: CoachTab) => {
    router.push(`/coach/${careTeamUserId}/${tab.toLowerCase()}`)
  }

  return (
    <FlexBox
      direction="row"
      align="center"
      justify={isMobile ? "space-around" : "flex-start"}
      gap={isMobile ? SPACING.space0 : SPACING.space4}
      wrap={false}
      style={{
        width: `min(100%, calc(600px - ${SPACING.space8}))`,
        margin: "0 auto",
      }}
    >
      <TabItem
        label={CoachTab.MESSAGES}
        onClick={() => setTab(CoachTab.MESSAGES)}
        icon={
          <FontAwesomeIcon
            icon={faComment}
            fontSize={16}
            color={
              tab === CoachTab.MESSAGES
                ? JoonUIColor.text.primary
                : JoonUIColor.text.secondary
            }
          />
        }
        showNotification={!!meTabCard?.unread_message?.message}
      />
      <TabItem
        label={CoachTab.ROUTINE}
        onClick={() => setTab(CoachTab.ROUTINE)}
        icon={
          <FontAwesomeIcon
            icon={faCalendarWeek}
            fontSize={16}
            color={
              tab === CoachTab.ROUTINE
                ? JoonUIColor.text.primary
                : JoonUIColor.text.secondary
            }
          />
        }
      />
      <TabItem
        label={CoachTab.SESSIONS}
        onClick={() => setTab(CoachTab.SESSIONS)}
        icon={
          <FontAwesomeIcon
            icon={faVideo}
            fontSize={16}
            color={
              tab === CoachTab.SESSIONS
                ? JoonUIColor.text.primary
                : JoonUIColor.text.secondary
            }
          />
        }
      />
    </FlexBox>
  )
}

export default CoachTabNav

const TabItem = ({
  label,
  onClick,
  icon,
  showNotification,
}: {
  label: string
  onClick: () => void
  icon: any
  showNotification?: boolean
}) => {
  const router = useRouter()
  const tab = router.query.coachTab as CoachTab | undefined
  const isSelected = tab === label

  return (
    <button
      onClick={onClick}
      style={{
        borderBottom: isSelected
          ? `4px solid ${JoonUIColor.semantic.primary}`
          : "4px solid transparent",
        padding: `${SPACING.space2} ${SPACING.space4}`,
        display: "flex",
        alignItems: "center",
        gap: SPACING.space2,
      }}
    >
      {icon}
      <Typography
        variant="bodySmallBold"
        color={
          isSelected ? JoonUIColor.text.primary : JoonUIColor.text.secondary
        }
      >
        {capitalizeFirstLetter(label)}
      </Typography>
      {showNotification && <NotificationDot />}
    </button>
  )
}
